import { client } from "../../../api/client";

export const createImportTemplateTag = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.post(process.env.REACT_APP_GATEWAY_URI,"templatesapi/importtemplatetag", body);
    } catch (error) {
        console.error("Error creating import template tag:", error);
        return [];
    }
  }
};

export const deleteImportTemplateTags = async (importTemplateId) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.delete(process.env.REACT_APP_GATEWAY_URI,`templatesapi/importtemplatetag/deletebyimporttemplateid/${importTemplateId}`);
    } catch (error) {
        console.error("Error deleting import template tags:", error);
        return [];
    }
  }
};